import type {CancelTokenSource} from 'axios';

export interface CancelableRequests {
	[key: string]: CancelTokenSource;
}

const CANCEL_MESSAGE = 'Request canceled';

class RequestStorage {
	store: CancelableRequests = {};

	add = (requestId: string, source: CancelTokenSource) => {
		this.store[requestId] = source;
	};

	remove = (requestId?: string) => {
		if (requestId) {
			delete this.store[requestId];
		}
	};

	cancel = (requestId: string, message?: string) => {
		if (this.store[requestId]) {
			this.store[requestId].cancel(message || CANCEL_MESSAGE);
			this.remove(requestId);
		}
	};
}

export default new RequestStorage();
